import store from 'src/store';
import {
    replaceGameStateTeams,
    updateCurrentActivityData,
    updateGameStateTeams
} from "src/actions/gameTime";
import {resetGameState} from "src/actions/gameTimeTeamActions";
import {registerTeamName, submitTeamForApproval} from "src/actions/gameTimeTeamActions";
import {isCurrentHost} from "../gameTime/common/gameTimeFunctions";
import {updateGameTime} from "src/actions/gameTime";
import {updateAppSettings} from "src/actions/foundationActions";
import {updateGameState} from "src/actions/gameTime";
import {clearActivityResponse} from "src/actions/gameTime";

export const resetForNewActivity = (activityKey,hideTopNav,headerColor,hostModule,gamePhase,gameMode) => {
    store.dispatch(updateAppSettings({hideTopNav:hideTopNav,activityHeadColor:headerColor,myRoomModalComponentName:hostModule}));
    store.dispatch(clearActivityResponse());
    store.dispatch(resetGameState({gameInProgress:false,teams:[],gamePhase:gamePhase,gameMode:gameMode,activityKey:activityKey}));
    store.dispatch(updateGameTime({currentHostModule:hostModule}));
};

export const gameInProgress = () => {
    return store.getState().gameState["gameInProcess"];
};

export const registerGameStarted = () => {
    store.dispatch(updateGameState({gameInProgress:true}))
};

export const registerGameOver = () => {
    store.dispatch(updateGameState({gameInProgress:false}))
};

export const initialSoloTeams = () => {
    return {"me":{teamid:"me",teamName:store.getState().user.firstname,clientid:store.getState().webSocketData.clientid}}
};

export const initialWithFriendsTeams = () => {
    let stateData = store.getState();
    let newTeams = {[stateData.webSocketData.clientid]:{
            teamid:stateData.webSocketData.clientid,
            teamName:stateData.user.firstname}
    };
    //eslint-disable-next-line
    Object.keys(stateData.gameState.teams).map((item)=>{
       let nt =  stateData.gameState.teams[item];
       newTeams[nt.clientid]= newTeams.hasOwnProperty(nt.clientid) ? newTeams[nt.clientid] : Object.assign({},nt);
    });
    return Object.assign({},newTeams);

};

export const isTeamAdded = (teamid) =>{
    let stateData = store.getState();
    let id = teamid ? teamid : stateData.webSocketData.clientid;
    return stateData.gameState?.teams?.hasOwnProperty(id)
};

export const prepTeams =(teams)=>{
    let stateData = store.getState();
    let allTeams = teams ? Object.assign({},teams) : Object.assign({},stateData.gameState.teams);
    //eslint-disable-next-line array-callback-return
    Object.keys(allTeams).map((key)=>{
        allTeams[key]=completeTeamObj(allTeams[key])
    });

    store.dispatch(updateCurrentActivityData({teams:allTeams}));

};

export const completeTeamObj = (team) =>{
    if(!team.hasOwnProperty("teamName")){team.teamName="tbd?";}
    if(!team.hasOwnProperty("socket")){team.socket=team.teamid;}
    team.score=0;
    return team;
};

export const obtainNextPlayer = ()=> {
    let stateData = store.getState();
    if(stateData.gameState?.teams) {
        let orderArr = Object.keys(stateData.gameState.teams).sort();
        let currentIndex = orderArr.indexOf(stateData.gameState.currentTeamsTurn);
        let nextIndex = currentIndex === orderArr.length - 1 ? 0 : currentIndex + 1;
        return orderArr[nextIndex];
    }
    else{
        return 0
    }
};

export const isMyTurn = () =>{
    return (
        store.getState().gameState?.teams
        &&
        (
            store.getState().gameState?.currentTeamsTurn===store.getState().webSocketData?.clientid
            ||
            store.getState().gameState?.teams[store.getState().gameState.currentTeamsTurn]?.clientid===store.getState().webSocketData?.clientid
        )
    );
};
/*
export const nextPlayer = (props) =>{
    store.dispatch(updateGameState({currentTeamsTurn:obtainNextPlayer(props)}));
};
*/

export const pruneTeams = () => {
    let stateData = store.getState();
    let teams = Object.assign({},stateData.gameState.teams);
    //eslint-disable-next-line
    Object.keys(teams).map((item)=>{
        if(!teamIsLocal(item)){
            if(!isTeamConnected(item)){
                delete teams[item];
            }
        }
    });
    store.dispatch(replaceGameStateTeams(teams));
};

export const shouldAdmitPerson = () => {
    let stateData = store.getState();
    return stateData.gameTime.automaticallyAddTeams &&
        stateData.gameTime.automaticallyAddEveryone &&
        stateData.webSocketData.clientid &&
        stateData.gameState.gamePhase==='preGame' &&
        (stateData.gameState.gameMode ==="withFriends") &&
        isCurrentHost()
};

export const admitTeam = (team) => {
    let stateData = store.getState();
    let admittedTeams = Object.assign({},stateData.gameState.teams);
    admittedTeams[team.teamid]=team;
    store.dispatch(updateGameStateTeams(team));
};

export const teamIsLocal = (teamid) => {
    let stateData = store.getState();
    let team = stateData.gameState.teams[teamid];
    return (team?.clientid===stateData.webSocketData.clientid || teamid===stateData.webSocketData.clientid);
};


export const removePlayer = (key) => {
    let stateData = store.getState();
    let teams = Object.assign({},stateData.gameState.teams);

    delete teams[key];
    store.dispatch(replaceGameStateTeams(teams));
};

export const isTeamConnected = (teamid) => {
    let stateData = store.getState();
    if(teamid.indexOf("player") > -1){
        return true;
    }
    if(teamid=== stateData.webSocketData.clientid){
        return true;
    }

    return stateData.networkGuests.hasOwnProperty(teamid);
};

//This function was submitTeamForApproval and changed to registerTeamName. correctly?
export const submitJoin = () => {
    let storeData = store.getState();
    store.dispatch(registerTeamName({
        teamName:storeData.user.firstname,
        teamid:storeData.webSocketData.clientid}
    ));
    store.dispatch(updateGameTime({teamStatus:"Pending"}));
};

export const addLocalPlayer = () => {
    let stateData = store.getState();
    let numberTeams = stateData.gameState.teams ? Object.keys(stateData.gameState.teams).length + 1 : 1;

    store.dispatch(updateGameStateTeams({teamid:"player" + numberTeams,teamName:"Player " + numberTeams,clientid:store.getState().webSocketData.clientid}));
};

export const addNetworkGuestsAsPlayers = (teams) => {
    let stateData = store.getState();
    //eslint-disable-next-line
    Object.keys(stateData.networkGuests).map((item)=>{
        let nt =  stateData.networkGuests[item];
        admitTeam({clientid:nt.clientid,teamName:nt.displayName,teamid:nt.clientid});
    });
    return teams;
};

export const doAddTeamsFromTrigger = () =>{
    let stateData = store.getState();
    if(isCurrentHost()){
        let newTeams = (
            stateData.gameState.gameMode==='solo'
                ? initialSoloTeams()
                : initialWithFriendsTeams()
        );
        store.dispatch(replaceGameStateTeams(newTeams));
        return {msg:"addedAsHost",code:1}
    }
    else {
        store.dispatch(submitTeamForApproval({
                teamName: stateData.user.firstname,
                teamid: stateData.webSocketData.clientid
            }
        ));
        setTimeout(()=>{
            store.dispatch(submitTeamForApproval(null
            ));
        },3000);
        return {msg:"addedAsGuest",code:2}
    }
};

export const awardPoints = () =>{
    let stateData = store.getState();
    let allTeams = {};
    Object.keys(stateData.gameState.teams).map((key)=>{
        let item = stateData.gameState.teams[key];
        let newTeam = Object.assign({},item);
        if(newTeam.teamid===stateData.gameState.currentTeamsTurn){
            newTeam.score = newTeam.score+ 1;
        }
        allTeams[newTeam.teamid]=newTeam;
        return newTeam;
    });
    return allTeams;
};

export const dataFromGameStateToCurrentActivityData = (fieldList) =>{
    let stateData = store.getState();
    fieldList=fieldList ? fieldList : stateData.currentActivityData.activityDataFieldList;
    let retme = {};

    //eslint-disable-next-line
    fieldList?.map((item)=>{
        //if(typeof stateData.gameState[item]==='object'){
        //    retme[item] = Object.assign({},stateData.gameState[item]);
       // }
        //else{
            retme[item] = stateData.gameState[item];
        //}
    });
    return retme;
};


export const createGametateFromCurrentActivityData = (fieldList) =>{
    let stateData = store.getState();
    fieldList=fieldList
        ? fieldList
        : stateData.currentActivityData.hasOwnProperty("activityDataFieldList")
            ? stateData.currentActivityData.activityDataFieldList
            : [];
    let changedKeys = {};

    //eslint-disable-next-line
    fieldList?.map((item)=>{
        //if(shouldImport(item)) {
            changedKeys[item] = stateData.currentActivityData[item];
        //}
    });
    return changedKeys;
};
/*
const shouldImport = (key) => {
    let stateData = store.getState();
    if(key ==="currentList" || key ==="currentListItems"){
        return false;
    }
    if(!stateData.currentActivityData.hasOwnProperty(key)){
        return false
    }
    if(stateData.currentActivityData[key] && typeof stateData.currentActivityData[key]==='object' && !Array.isArray(stateData.currentActivityData[key]) && Object.keys(stateData.currentActivityData[key]).length===0 ){
        return false;
    }
    if(typeof stateData.currentActivityData[key] !=='object'){
        return stateData.currentActivityData[key] !== stateData.gameState[key];
    }

    return true;
};
*/
export const convertTeamsToWithFriends = () => {
    let stateData = store.getState();
    let teams = Object.assign({},stateData.gameState.teams);
    if(teams.hasOwnProperty("me")){
        teams[stateData.webSocketData.clientid] = JSON.parse(JSON.stringify(teams.me));
        teams[stateData.webSocketData.clientid].teamid=stateData.webSocketData.clientid;
        delete teams.me;
        store.dispatch(replaceGameStateTeams(teams));
    }
};

export const createWithFriendsGame = () => {
    let stateData = store.getState();
    //make teams of one person
    let numTeams = stateData.gameState.teams ? Object.keys(stateData.gameState.teams).length : 0;
    if(numTeams) {
        store.dispatch(replaceGameStateTeams(initialWithFriendsTeams()));
    }
    else{
        convertTeamsToWithFriends();
    }
    //make "sendData" to false;
    store.dispatch(updateGameState({gameMode:"withFriends"}));
    store.dispatch(updateGameTime({sendWSData:true,teamStatus:"Joined"}));
};

export const obtainWinner = () =>{
    let highScore=0;
    let team=[];
    let stateData = store.getState();
    if(stateData.gameState.teams) {
        //eslint-disable-next-line
        Object.keys(stateData.gameState.teams).map((key) => {
            let item = stateData.gameState.teams[key];
            if (item.score > highScore) {
                highScore = item.score;
                team = [item];
            }
            else if(item.score === highScore){
                team.push(item);
            }
        });
    }
    return team;
};

export const formatWinnerNames = (teams) =>{
    switch (teams.length) {
        case 1:
            return teams[0].teamName;
        case 2:
            return teams[0].teamName + " and " + teams[1].teamName;
        default:
            let nameString="";
            //eslint-disable-next-line
            teams.map((item,idx)=>{
                nameString=nameString + item.teamName;
                if(idx===teams.length-2){
                    nameString = nameString + " and ";
                }
                else if(idx<teams.length-1){
                    nameString = nameString + ",";
                }
            });
            return nameString;
    }
};


